/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Study_FieldInputs */

const en_study_field = /** @type {(inputs: Study_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field of study`)
};

const de_study_field = /** @type {(inputs: Study_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fachrichtung`)
};

/**
* | output |
* | --- |
* | "Field of study" |
*
* @param {Study_FieldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const study_field = /** @type {((inputs?: Study_FieldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Study_FieldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_study_field(inputs)
	return en_study_field(inputs)
});